import styled from '@emotion/styled';
import { InputVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface TitleType {
    isActive: boolean;
}

interface TitleChooseBoxWrapperPropsType {
    variant: InputVariantType | null;
}

export const TitleChooseBoxWrapper = withConfig(theme => styled('div', { label: 'TitleChooseBoxWrapper' })<TitleChooseBoxWrapperPropsType>`
    align-items: center;
    background-color: ${theme.star.form.dark.bgColor};
    display: flex;
    flex: 1 0 90px;
    height: 40px;
    justify-content: space-between;
    padding: 10px 12px;
    cursor: pointer;
    border-radius: ${({ variant }): string => variant === InputVariantType.SECONDARY ? theme.star.radius.small : '0'};
    &:not(:last-of-type) {
        margin-right: 6px;
    }
`);

export const TitleChooseBoxTitle = withConfig(theme => styled('span', { label: 'TitleChooseBoxTitle' })<TitleType>`
    font-size: ${theme.star.fontSize.xRegular};
    color: ${({ isActive }): string =>
        isActive ? theme.star.form.txtColor : theme.star.form.txtColorSecondary};
    text-transform: capitalize;
`);
